import { oz } from '@weft/utils';
import { InvoiceSyncAttemptResultSchema } from './invoice-sync-attempt-result';

export const NetSuiteSyncInvoicesResponseSchema = oz.object({
  invoicesSyncAttemptsResults: InvoiceSyncAttemptResultSchema.array(),
}).openapi('netSuiteSyncInvoicesResponse');

export type NetSuiteSyncInvoicesResponse = oz.infer<typeof NetSuiteSyncInvoicesResponseSchema>;